import React, { useState } from 'react';
import { ListDashItens } from '../../../../../../components/NovoSistema/ListDashItens';
import ModalImageDash from '../../../../../../components/NovoSistema/ModalImageDash';
import SubTitle from '../../../../../../components/NovoSistema/SubTitle';

export default function RbEbitdaLl() {
  const [openModal, setOpenModal] = useState(false);
  const prefix = '/docs/controladoria/dashboard/BAF/';
  const nameImage = 'rb-ebitda-ll';
  return (
    <main>
      <SubTitle text="ANÁLISE – Receitas Bruta | EBITDA | Lucro Líquido" />
      <ListDashItens>
        <li>Corte: AGO21.</li>
        <li>RB em alta impactada por aumento nos casos de internação decorrentes do COVID19.</li>
        <li>LL impactado por ganhos não planejados no Mercado de Opções</li>
      </ListDashItens>
      <img
        onClick={() => setOpenModal(true)}
        src={`${prefix}${nameImage}.png`}
        alt={nameImage}
        style={{ width: '100%' }}
      />
      {openModal && <ModalImageDash close={setOpenModal} src={`${prefix}${nameImage}.png`} alt={nameImage} />}
    </main>
  );
}
